import { render } from "./CatalogDetails.vue?vue&type=template&id=aa6ec88a&ts=true"
import script from "./CatalogDetails.vue?vue&type=script&lang=ts"
export * from "./CatalogDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__